import { Link } from "react-router-dom";
import type { TitleCard as TitleCardModel } from "@/api/types";

interface Props {
  title: TitleCardModel;
  wide?: boolean;
  progress?: number;
  subtitle?: string;
}

/** One poster in a row. Deliberately cheap: a home page renders ~100 of these. */
export function TitleCard({ title, wide = false, progress, subtitle }: Props) {
  const art = wide ? title.backdrop_url : title.poster_url ?? title.backdrop_url;
  return (
    <Link
      to={`/title/${title.id}`}
      className={wide ? "card card--wide" : "card"}
      aria-label={title.name}
    >
      <div className="card__art" style={{ background: title.dominant_color }}>
        {art ? (
          <img src={art} alt="" loading="lazy" decoding="async" />
        ) : (
          <span className="card__fallback">{title.name}</span>
        )}
        {title.is_original && <span className="card__badge">Original</span>}
        {progress !== undefined && progress > 0 && (
          <div className="card__progress">
            <span style={{ width: `${Math.min(100, progress * 100)}%` }} />
          </div>
        )}
      </div>
      <div className="card__meta">
        <div className="card__name">{title.name}</div>
        <div className="card__sub">
          {subtitle ??
            [title.release_year, title.maturity_rating, title.genres[0]]
              .filter(Boolean)
              .join(" · ")}
        </div>
      </div>
    </Link>
  );
}
